<template>
    <div class="add-form">
        <div v-loading="loading">
            <el-form
                ref="ruleFormRef"
                :model="ruleForm"
                :rules="rules"
                label-width="220px"
            >
                <el-form-item
                    label="1.本次沟通是否有效？"
                    prop="isEffectiveCommunication"
                >
                    <el-radio-group
                        v-model="ruleForm.isEffectiveCommunication"
                        @change="effectiveCommunicationChange"
                    >
                        <el-radio :value="1">有效</el-radio>
                        <el-radio :value="0">无效</el-radio>
                    </el-radio-group>
                </el-form-item>
                <template v-if="ruleForm.isEffectiveCommunication == 0">
                    <el-form-item label="2.本次的沟通方式？" prop="type">
                        <el-radio-group v-model="ruleForm.type" :disabled="Boolean(callType.length)">
                            <el-radio
                                value="企微"
                                v-if="ruleForm.isEffectiveCommunication == 1"
                                >企微</el-radio
                            >
                            <el-radio value="电话">电话</el-radio>
                            <el-radio value="面谈">面谈</el-radio>
                            <el-radio value="其他">其他</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="3.无效的原因" prop="content">
                        <el-input
                            v-model="ruleForm.content"
                            maxlength="200"
                            show-word-limit
                            :rows="4"
                            type="textarea"
                        />
                    </el-form-item>
                    <el-form-item label="4.下次联系时间" prop="nextTime">
                        <el-date-picker
                            :disabled-date="disabledDate"
                            v-model="ruleForm.nextTime"
                            type="date"
                            style="width: 180px"
                            value-format="YYYY-MM-DD"
                            placeholder="请选择"
                        />
                    </el-form-item>
                </template>
                <template v-if="ruleForm.isEffectiveCommunication == 1">
                    <div style="display: flex; align-items: center">
                        <el-form-item label="2.本次的沟通方式？" prop="type" >
                            <el-radio-group v-model="ruleForm.type" :disabled="Boolean(callType.length)">
                                <el-radio value="企微">企微</el-radio>
                                <el-radio value="电话">电话</el-radio>
                                <el-radio value="面谈">面谈</el-radio>
                                <el-radio value="其他">其他</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item
                            label="附件"
                            prop="files"
                            label-width="80"
                            v-if="canFiles"
                        >
                            <file-upload
                                :fileSize="1024"
                                :limit="1"
                                :file-type="[
                                    'doc',
                                    'xls',
                                    'xlsx',
                                    'ppt',
                                    'txt',
                                    'pdf',
                                    'jpg',
                                    'png',
                                    'mp4',
                                    'mp3',
                                    'flac',
                                    'aiff',
                                    'm4a',
                                    'aac',
                                ]"
                                :isShowTip="false"
                                v-model="ruleForm.files"
                                @success="getAudioDuration"
                            />
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item
                            label="3.是否确定了下次到访时间？"
                            prop="isPreVisitDate"
                        >
                            <el-radio-group
                                v-model="ruleForm.isPreVisitDate"
                                @change="preVisitDateChange"
                            >
                                <el-radio :value="1">是</el-radio>
                                <el-radio :value="0">否</el-radio>
                            </el-radio-group>
                            <div style="display: flex">
                                <el-form-item
                                    label-width="120"
                                    label="约定到访时间"
                                    prop="preVisitDate"
                                    v-if="ruleForm.isPreVisitDate == 1"
                                >
                                    <el-date-picker
                                        :disabled-date="disabledDate2"
                                        v-model="ruleForm.preVisitDate"
                                        type="date"
                                        style="width: 180px"
                                        value-format="YYYY-MM-DD"
                                        placeholder="请选择"
                                    />
                                </el-form-item>
                                <el-form-item
                                    label-width="120"
                                    label="下次联系时间"
                                    prop="nextTime"
                                    v-if="ruleForm.isPreVisitDate == 0"
                                >
                                    <el-date-picker
                                        :disabled-date="disabledDate"
                                        v-model="ruleForm.nextTime"
                                        type="date"
                                        style="width: 180px"
                                        value-format="YYYY-MM-DD"
                                        placeholder="请选择"
                                    />
                                </el-form-item>
                            </div>
                        </el-form-item>
                    </div>
                    <el-form-item
                        label="4.是否推荐了课程？"
                        prop="isRecommended"
                    >
                        <el-radio-group
                            v-model="ruleForm.isRecommended"
                            @change="isRecommendedChange"
                        >
                            <el-radio :value="0">是</el-radio>
                            <el-radio :value="1">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <template v-if="ruleForm.isRecommended == 0">
                        <el-form-item
                            label="最近一次推荐的课程是？"
                            prop="recommendedCoursesName"
                        >
                            <productSelect
                                style="width: 588px"
                                status="启用"
                                value="productName"
                                @getInfo="getProductInfo"
                                v-model="ruleForm.recommendedCoursesName"
                            />
                        </el-form-item>
                        <el-form-item
                            label="是否已对课程报价"
                            prop="isCourseQuotation"
                        >
                            <el-radio-group
                                v-model="ruleForm.isCourseQuotation"
                                @change="courseQuotationChange"
                            >
                                <el-radio :value="1">是</el-radio>
                                <el-radio :value="0">否</el-radio>
                            </el-radio-group>
                            <div v-if="ruleForm.isCourseQuotation == 1">
                                <el-form-item
                                    label-width="120"
                                    label="具体报价"
                                    prop="courseQuotation"
                                >
                                    <el-input-number
                                        placeholder="请输入"
                                        v-model="ruleForm.courseQuotation"
                                        :min="0"
                                        :precision="2"
                                        :controls="false"
                                    />
                                </el-form-item>
                            </div>
                        </el-form-item>
                    </template>
                    <el-form-item v-if="showPlayAudio">
                            <el-button type="primary" plain @click="playAudio()">播放音频+文字</el-button>
                    </el-form-item>
                    <el-form-item label="5.本次沟通的主要内容" prop="content">
                        <el-input
                            v-model="ruleForm.content"
                            maxlength="200"
                            show-word-limit
                            :rows="4"
                            type="textarea"
                        />
                    </el-form-item>
                    <el-form-item
                        label="6.学员方便时间"
                        prop="studentClassSchedule"
                    >
                        <el-select
                            multiple
                            style="width: 588px"
                            v-model="ruleForm.studentClassSchedule"
                            filterable
                            placeholder="请选择"
                            clearable
                        >
                            <el-option
                                v-for="item in studentClassScheduleList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="7.学员性别" prop="sex">
                        <el-radio-group v-model="ruleForm.sex">
                            <el-radio value="女">女</el-radio>
                            <el-radio value="男">男</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div style="display: flex; align-items: center">
                        <el-form-item label="8.学员身份" prop="stuStatus">
                            <el-select
                                v-model="ruleForm.stuStatus"
                                placeholder="请选择"
                                filterable
                                clearable
                            >
                                <el-option
                                    v-for="item in identityStatusList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label-width="80"
                            v-if="['3', '4', '5'].includes(ruleForm.stuStatus)"
                            label="岗位"
                            prop="job"
                        >
                            <el-select
                                v-model="ruleForm.job"
                                placeholder="请选择"
                                filterable
                                clearable
                            >
                                <el-option
                                    v-for="item in jobList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                />
                            </el-select>
                        </el-form-item>
                    </div>

                    <el-form-item
                        label="9.学员目前从事的行业"
                        prop="currentIndustry"
                    >
                        <el-select
                            style="width: 588px"
                            v-model="ruleForm.currentIndustry"
                            filterable
                            placeholder="搜索/请选择"
                            clearable
                        >
                            <el-option
                                v-for="item in standardIndustryList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="10.学员希望从事的行业"
                        prop="hopeIndustry"
                    >
                        <el-select
                            style="width: 588px"
                            v-model="ruleForm.hopeIndustry"
                            filterable
                            placeholder="搜索/请选择"
                            clearable
                        >
                            <el-option
                                v-for="item in standardIndustryList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="11.学员的意向等级" prop="saleLevel">
                        <el-radio-group
                            v-model="ruleForm.saleLevel"
                            placeholder="请选择"
                        >
                            <el-radio label="A" value="A" />
                            <el-radio label="B" value="B" />
                            <el-radio label="C" value="C" />
                            <el-radio label="D" value="D" />
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="12.学员的需求" prop="studentNeeds">
                        <el-select
                            style="width: 588px"
                            v-model="ruleForm.studentNeeds"
                            filterable
                            placeholder="请选择"
                            clearable
                        >
                            <el-option
                                v-for="item in studentNeedsList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="13.学员是否有就业需求？"
                        prop="isEmployment"
                    >
                        <el-radio-group v-model="ruleForm.isEmployment">
                            <el-radio :value="1">是</el-radio>
                            <el-radio :value="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </template>
            </el-form>
        </div>
    </div>
</template>

<script setup>
import dayjs from "dayjs";
import { ElMessage } from "element-plus";
import {
    selectStandardIndustryApi,
    insertFollow,
    selectFollowOneApi,
    selectStandardIndustryJobApi,
} from "@/api/studentmange";
import productSelect from "@/components/productSelect";
const { baseInfo, type, id,callType } = defineProps({
    baseInfo: {
        type: Object,
        default: () => ({}),
    },
    type: {
        type: String,
        default: "1", //意向学员 1  报名学员 2
    },
    id: {
        type: String,
        default: "", //数据id
    },
    //是否显示附件上传
    canFiles:{
        type:Boolean,
        default:true
    },
    callType:{ //沟通方式
        type: String,
        default: "",
    },
    showPlayAudio:{
        type:Boolean,
        default:false
    }
});
const emits = defineEmits(["success",'playAudio']);
const playAudio = ()=>{
    emits('playAudio')
}
const ruleFormRef = ref();
const ruleForm = ref({
    isEffectiveCommunication: null,
    content: "",
    nextTime: "",
    isPreVisitDate: null,
    preVisitDate: "",
    type: "",
    isRecommended: null,
    recommendedCourses: "",
    recommendedCoursesName: "",
    isCourseQuotation: null,
    courseQuotation: null,
    files: "",
    fileType: 0,
    sex: "",
    stuStatus: "",
    job: "",
    currentIndustry: "",
    hopeIndustry: "",
    studentNeeds: "",
    saleLevel: "",
    studentClassSchedule: [],
    isEmployment: null,
});
const { proxy } = getCurrentInstance();
const identityStatusList = computed(() => {
    const { identity_status } = proxy.useDict("identity_status");
    return [...unref(identity_status)];
});
const studentNeedsList = computed(() => {
    const { student_needs } = proxy.useDict("student_needs");
    return [...unref(student_needs)];
});
const studentClassScheduleList = computed(() => {
    const { student_class_schedule } = proxy.useDict("student_class_schedule");
    return [...unref(student_class_schedule)];
});
const disabledDate = (date) => {
    return dayjs(date).format("YYYYMMDD") <= dayjs().format("YYYYMMDD");
};
const disabledDate2 = (date)=>{
    return dayjs(date).format("YYYYMMDD") < dayjs().format("YYYYMMDD");
}
const rules = reactive({
    isEffectiveCommunication: [
        { required: true, message: "必填项", trigger: "change" },
    ],
    content: [{ required: true, message: "必填项", trigger: "blur" }],
    nextTime: [{ required: true, message: "必填项", trigger: "change" }],
    isPreVisitDate: [{ required: true, message: "必填项", trigger: "change" }],
    type: [{ required: true, message: "必填项", trigger: "change" }],
    preVisitDate: [{ required: true, message: "必填项", trigger: "change" }],
    isRecommended: [{ required: true, message: "必填项", trigger: "blur" }],
    recommendedCourses: [
        { required: true, message: "必填项", trigger: "change" },
    ],
    isCourseQuotation: [
        { required: true, message: "必填项", trigger: "change" },
    ],
    courseQuotation: [{ required: true, message: "必填项", trigger: "change" }],
    sex: [{ required: true, message: "必填项", trigger: "change" }],
    stuStatus: [{ required: true, message: "必填项", trigger: "change" }],
    currentIndustry: [{ required: true, message: "必填项", trigger: "change" }],
    hopeIndustry: [{ required: true, message: "必填项", trigger: "change" }],
    saleLevel: [{ required: true, message: "必填项", trigger: "change" }],
    studentNeeds: [{ required: true, message: "必填项", trigger: "change" }],
    job: [{ required: true, message: "必填项", trigger: "change" }],
    recommendedCoursesName: [
        { required: true, message: "必填项", trigger: "change" },
    ],
    studentClassSchedule: [
        { required: true, message: "必填项", trigger: "change" },
    ],
    isEmployment: [{ required: true, message: "必填项", trigger: "blur" }],
});
const standardIndustryList = ref([]);
const selectStandardIndustry = async () => {
    const res = await selectStandardIndustryApi();
    standardIndustryList.value = res.data;
};
const jobList = ref([]);
const selectStandardIndustryJob = async () => {
    const res = await selectStandardIndustryJobApi();
    jobList.value = res.data;
};
const close = () => {
    ruleForm.value = {
        isEffectiveCommunication: null,
        content: "",
        nextTime: "",
        isPreVisitDate: null,
        preVisitDate: "",
        type: "",
        isRecommended: null,
        recommendedCourses: "",
        recommendedCoursesName: "",
        isCourseQuotation: null,
        courseQuotation: null,
        files: "",
        fileType: 0,
        sex: "",
        stuStatus: "",
        job: "",
        currentIndustry: "",
        hopeIndustry: "",
        studentNeeds: "",
        saleLevel: "",
        studentClassSchedule: [],
        isEmployment: null,
        attendanceClassId:""
    };
};
onUnmounted(()=>{
    close()
})
const route = useRoute();
const loading = ref(false);
const getPrevOne = async () => {
    if(!id){
        return
    }
    loading.value = true;
    let params = {
        id: id,
        type: type,
    };
    const { data } = await selectFollowOneApi(params);
    loading.value = false;
    if (data) {
        const {
            isEffectiveCommunication,
            isCourseQuotation,
            courseQuotation,
            recommendedCourses,
            recommendedCoursesName,
            stuStatus,
            currentIndustry,
            hopeIndustry,
            studentNeeds,
            saleLevel,
            job,
            sex,
            studentClassSchedule,
            isEmployment,
        } = data;
        if (isEffectiveCommunication) {
            // ruleForm.value.isEffectiveCommunication = isEffectiveCommunication;
            ruleForm.value.isCourseQuotation = isCourseQuotation;
            ruleForm.value.courseQuotation = courseQuotation;
            ruleForm.value.recommendedCourses = recommendedCourses;
            ruleForm.value.recommendedCoursesName = recommendedCoursesName;
            ruleForm.value.stuStatus = stuStatus;
            ruleForm.value.currentIndustry = currentIndustry;
            ruleForm.value.hopeIndustry = hopeIndustry;
            ruleForm.value.studentNeeds = studentNeeds;
            ruleForm.value.saleLevel = saleLevel;
            ruleForm.value.job = job;
            ruleForm.value.sex = sex;
            ruleForm.value.studentClassSchedule = studentClassSchedule;
            ruleForm.value.isEmployment = isEmployment;

        }
        if (route.query.isFollow) {
            ruleForm.value.content = `${decodeURIComponent(route.query.followTag)}`;
            ruleForm.value.attendanceClassId = route.query.courseId;
        }
    }
};
const getProductInfo = (item) => {
    ruleForm.value.recommendedCourses = item.id;
};
function validateForm(){
    return new Promise((resolve,reject)=>{
        ruleFormRef.value.validate((valid, fields) => {
                if (valid) {
                    resolve(true)
                } else {
                    resolve(false)
                }
            }
        );
    })

}
function submitAdd(accept={}) {
    return new Promise((reslove,reject)=>{
        ruleFormRef.value.validate((valid) => {
            if (valid) {
                let params = {
                    ...ruleForm.value,
                };
                if (params.files) {
                    const fileType = params.files.match(/\.(\w+)$/);
                    params.fileType = [
                        "mp3",
                        "flac",
                        "aiff",
                        "m4a",
                        "aac",
                    ].includes(fileType[1]?.toLocaleLowerCase())
                        ? 1
                        : 0;
                }
                if (type == "1") {
                    params.leadId = id;
                }
                if (type == "2") {
                    params.studentId = id;
                }
                insertFollow({...params,...accept})
                    .then((res) => {
                        if (res.code == 200) {
                            ElMessage({
                                message: "添加成功",
                                type: "success",
                            });
                            emits("success");
                            reslove(params)
                        }
                    })
                    .catch((error) => {
                        reject('接口错误')
                    });
            } else {
                console.log("error submit!");
                reject('表单验证错误')
            }
        });
    })
}
defineExpose({
    submitAdd,
    validateForm
})
const preVisitDateChange = (val) => {
    ruleForm.value.preVisitDate = "";
    ruleForm.value.nextTime = "";
};
const courseQuotationChange = (val) => {
    ruleForm.value.courseQuotation = "";
};
const isRecommendedChange = (val) => {
    if (val === 1) {
        ruleForm.value.recommendedCourses = "";
        ruleForm.value.recommendedCoursesName = "";
        ruleForm.value.isCourseQuotation = null;
        ruleForm.value.courseQuotation = null;
    }
};
const effectiveCommunicationChange = (val) => {
    ruleForm.value = {
        isEffectiveCommunication: val,
        content: "",
        nextTime: "",
        isPreVisitDate: null,
        preVisitDate: "",
        type: "",
        recommendedCourses: "",
        isCourseQuotation: null,
        files: "",
        fileType: 0,
        sex: "",
        stuStatus: "",
        currentIndustry: "",
        hopeIndustry: "",
        studentNeeds: "",
        saleLevel: "",
    };
    if (val) {
        getPrevOne();
    }
    if(callType){
        ruleForm.value.type = '电话'
    }
};
selectStandardIndustry();
selectStandardIndustryJob();

//获取音频时长
function getAudioDuration(file) {
    const fileType = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLocaleLowerCase();
    if (!["mp3", "flac", "aiff", "m4a", "aac"].includes(fileType)) return;
    const audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
    const fileReader = new FileReader();
    fileReader.onload = (event) => {
        const arrayBuffer = event.target.result; // 读取到的ArrayBuffer数据
        audioContext.decodeAudioData(
            arrayBuffer,
            function (buffer) {
                // 解码音频数据
                ruleForm.value.fileTime = Math.floor(buffer.duration); // 获取音频时长（秒）
            },
            function (error) {
                // 解码失败的处理函数
                console.error("解码音频数据失败:", error);
            }
        );
    };
    fileReader.readAsArrayBuffer(file.raw); // 读取文件内容为ArrayBuffer
}
</script>

<style lang="scss" scoped>
.add {
    :deep(.el-dialog) {
        .el-dialog__header {
            border-bottom: 1px solid #dcdfe6;
            margin-right: 0;
        }
        .el-upload-list {
            margin: 0;
        }
        .el-form {
            .el-form-item__label {
            }
        }
    }
}
</style>
